import Icon from 'veui/components/Icon'

Icon.register({
  refresh: {
    paths: [
      {
        d: 'M24 3c5.39 0 10.46 2.04 14.3 5.63V5.2a2 2 0 014 0v9.3a2 2 0 01-2 2H31a2 2 0 110-4h5.63a2 2 0 01-.42-.33 17 17 0 104.65 14.01 2 2 0 013.97.51A21 21 0 1124 3z'
      }
    ],
    width: '48',
    height: '48'
  }
})
